import { gql } from "@apollo/client";

/** Every flag, and where every grown-up account stands on it. Admin only. */
export const GET_FEATURE_FLAGS = gql`
  query GetFeatureFlags {
    featureFlags {
      id
      key
      name
      description
      enabledCount
      accounts {
        id
        accountId
        name
        email
        role
        learnerCount
        enabled
      }
    }
  }
`;
